import styled from 'styled-components'
import Browser from '../../../services/Browser'

/**
 * @param {string} gap
 * set the column gap if needed
 */
export const StyledRadioGroup = styled.div`
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	grid-column-gap: ${({ gap }) => (gap ? gap : '0')};
	flex-wrap: nowrap;

	& > * {
		flex: 1;

		&:not(:first-child) {
			margin-left: ${({ gap }) =>
				Browser.isIE() ? '15px' : gap ? 'unset' : '-1px'};
		}
	}
`
